import React, { useState } from "react";
import { Redirect, Route } from "react-router-dom";

import IdleTimeoutModal from "../modal/IdleTimeoutModal";

import { localStorageToken,authStorage } from "../../utils/variables";

const PrivateRoute = ({ children, ...rest }) => {
  // States

  const token = authStorage.getItem(localStorageToken);

  const [showIdleModal, setShowIdleModal] = useState(false);

  return (
    <>
      <IdleTimeoutModal
        setShowIdleModal={setShowIdleModal}
        open={showIdleModal}
        onClose={() => setShowIdleModal(false)}
      />

      <Route
        {...rest}
        render={({ location }) =>
          token ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location },
              }}
            />
          )
        }
      />
    </>
  );
};

export default PrivateRoute;
